<div class="kyb-entity-section">
  @if (showHeader) {
    @if (showEntityName) {
      <div class="entity-name mat-body-strong">{{ entity.entityName }}</div>
    }

    <div class="section-heading-bar">
      <span class="section-heading-text">{{ heading() }}</span>
    </div>
  }

  @if (showPeopleTable()) {
    <table class="kyb-people-table">
      <thead>
        <tr>
          <th class="col-select"></th>
          <th class="col-name">Name</th>
          <th class="col-role">Business Role</th>
          <th class="col-ownership">Ownership %</th>
          <th class="col-tick">Guarantor</th>
          <th class="col-tick">Signer</th>
        </tr>
      </thead>
      <tbody>
        @for (person of entity.people; track person.stakeholderId) {
          <tr>
            <td class="col-select">
              <!-- Select and guarantor locks always force a tick; only Signer can show a locked cross. -->
              <kyb-lock-tick
                [checked]="isSelected(person)"
                [locked]="isSelectLocked(person)"
                [readonly]="readonly || isSelectHeldByRole(person)"
                [showLockedCross]="false"
                [tooltip]="selectTooltip(person)"
                (checkedChange)="onSelectedChange(person, $event)">
              </kyb-lock-tick>
            </td>
            <td class="col-name">
              <div>
                {{ fullName(person) }}
                @if (hasLinkedAlias(person)) {
                  <span class="mdi mdi-link-variant linked-alias-icon"
                        [matTooltip]="linkedAliasTooltip(person)"
                        [attr.aria-label]="linkedAliasTooltip(person)"></span>
                }
              </div>
              @if (person.isSigner && signingRowFor(person); as signingRow) {
                <div class="same-person-note">Signs as {{ signingRoleLabel(signingRow) }} ({{ fullName(signingRow) }})</div>
              }
              @if (resolutionFor(person); as resolution) {
                <div class="resolution-note">
                  {{ resolution.kind === 'existing' ? 'Using existing' : 'Adding' }}:
                  {{ resolution.name }}
                  @if (!readonly) {
                    <button type="button" class="undo-resolution" (click)="onUndoResolution(person)">Undo</button>
                  }
                </div>
              }
            </td>
            <td class="col-role">{{ roleLabel(person) }}</td>
            <td class="col-ownership">{{ ownershipLabel(person) }}</td>
            <td class="col-tick">
              <kyb-lock-tick
                [checked]="isRoleLocked(person) ? true : person.isGuarantor"
                [locked]="isRoleLocked(person)"
                [readonly]="readonly"
                [showLockedCross]="false"
                [tooltip]="guarantorTooltip(person)"
                (checkedChange)="onGuarantorChange(person, $event)">
              </kyb-lock-tick>
            </td>
            <td class="col-tick">
              <kyb-lock-tick
                [checked]="signerChecked(person)"
                [locked]="isSignerLocked(person)"
                [readonly]="readonly"
                [showLockedCross]="useLockAffordances"
                [tooltip]="signerTooltip(person)"
                (checkedChange)="onSignerChange(person, $event)">
              </kyb-lock-tick>
            </td>
          </tr>
        }
        @if (!entity.people.length) {
          <tr>
            <td class="no-people" colspan="6">
              <div class="no-people-content">
                <span>No individuals returned from KYB for this entity.</span>
                @if (showManualEntry()) {
                  <button type="button" mat-stroked-button color="primary" (click)="manualEntry.emit()">
                    Enter manually
                  </button>
                }
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
